import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

//////////////////////////////////////////////////////////////////////////////////////////////////
import pt from 'vee-validate/dist/locale/pt_PT';
import es from 'vee-validate/dist/locale/es';
import en from 'vee-validate/dist/locale/en';
import fr from 'vee-validate/dist/locale/fr';
import zh from 'vee-validate/dist/locale/zh_CN';
import VeeValidate from 'vee-validate'
import { Validator } from 'vee-validate'

Validator.localize('pt', pt);
Validator.localize('es', es);
Validator.localize('en', en);
Validator.localize('fr', fr);
Validator.localize('zh', zh);

Vue.use(VeeValidate, {
  errorBagName: 'errorvee',
});

//////////////////////////////////////////////////////////////////////////////////////////////////
import Vuetify from 'vuetify'
Vue.use(Vuetify)
//////////////////////////////////////////////////////////////////////////////////////////////////
import VueResource from 'vue-resource'
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
//Vue.http.options.emulateHTTP = true;
//////////////////////////////////////////////////////////////////////////////////////////////////
import Carousel3d from 'vue-carousel-3d'
Vue.use(Carousel3d)
//////////////////////////////////////////////////////////////////////////////////////////////////

new Vue({
  render: h => h(App),
}).$mount('#app')
